export const promisify = (fn) => {
	return (...args) =>
		new Promise((resolve, reject) => {
			fn(...args, (error, result) => {
				if (error) {
					reject(error);
					return;
				}

				resolve(result);
			});
		});
};

export default { promisify };
